import React from 'react';
import { Modal, Button } from "@forge/common";
import { CREATE_COURSE_CONSTANTS } from "../utils/constants";

interface PublishWarningModalProps {
    isOpen: boolean;
    onClose: () => void;
    onPublish: () => void;
}

const PublishWarningModal: React.FC<PublishWarningModalProps> = ({
    isOpen,
    onClose,
    onPublish
}) => {
    if (!isOpen) return null;

    const handlePublish = () => {
        onClose();
        onPublish();
    };

    return (
        <Modal
            backdrop={true}
            footerLeft={
                <div className="flex justify-center">
                    <Button
                        className="text-base font-bold mr-4"
                        id="cancel-publish-warning"
                        data-testid="cancel-publish-warning"
                        onClick={onClose}
                        size="regular"
                        variant="secondary"
                    >
                        {CREATE_COURSE_CONSTANTS.PUBLISH_VALIDATION_MODAL.BUTTONS.CANCEL}
                    </Button>
                    <Button
                        className="text-base font-bold"
                        id="publish-without-saving"
                        data-testid="publish-without-saving"
                        onClick={handlePublish}
                        size="regular"
                        variant="primary"
                    >
                        {CREATE_COURSE_CONSTANTS.PUBLISH_VALIDATION_MODAL.BUTTONS.DISCARD_CHANGES_AND_PUBLISH}
                    </Button>
                </div>
            }
            onModalClose={onClose}
            title="Unsaved Changes Detected"
        >
            <div className="space-y-4">
                <p>{CREATE_COURSE_CONSTANTS.PUBLISH_VALIDATION_MODAL.TITLE}</p>
                <p><strong>Options:</strong></p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                    <li>
                        <strong>
                            {CREATE_COURSE_CONSTANTS.PUBLISH_VALIDATION_MODAL.BUTTONS.DISCARD_CHANGES_AND_PUBLISH}:
                        </strong>{' '}
                        {CREATE_COURSE_CONSTANTS.PUBLISH_VALIDATION_MODAL.LIST1}
                    </li>
                    <li>
                        <strong>
                            {CREATE_COURSE_CONSTANTS.PUBLISH_VALIDATION_MODAL.BUTTONS.CANCEL}:
                        </strong>{' '}
                        {CREATE_COURSE_CONSTANTS.PUBLISH_VALIDATION_MODAL.LIST2}
                    </li>
                </ul>
            </div>
        </Modal>
    );
};

export default PublishWarningModal;